<!-- @format -->

@if (viewLoaded) {
  <div class="container">
    <sis-tab-navigation [tabs]="tabs" [wide]="'sm'"></sis-tab-navigation>
    <ui-view></ui-view>
  </div>
}
